import { useState } from 'react';
import { useMutation } from 'react-query';

import { useTeamStore } from './useTeamStore';

import useToast from '@/hooks/useToast';
import { requestNewCaptain } from '@/services/commonsTeam';
import { TeamActionTypes } from '@/store';
import { RequestNewCaptain, TemplatePlayer } from '@/types/team';

export const useHandleChangeCaptain = (isF5 = false) => {
  const { dispatch } = useTeamStore();
  const [updateCaptain, setIsUpdateCaptain] = useState({
    id: 0,
    isUpdateCaptain: false,
  });
  const toast = useToast();

  const {
    data: responseNewCaptain,
    isLoading: isLoadingNewCaptain,
    mutateAsync: postNewCaptain,
  } = useMutation(
    async (data: RequestNewCaptain) => await requestNewCaptain(data, isF5)
  );

  const resetState = () => {
    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: {
        playerDetailsModalOpen: false,
        showPlayersListTransfer: false,
      },
    });
  };

  const handleNewCaptain = async (player: TemplatePlayer) => {
    // no se pueden realizar cambios por la veda
    // se deja pasar al servicio de backend
    // if (userInitialData?.veda) {
    //   toast.show(TEXTS.veda);
    //   resetState();
    //   return;
    // } else
    // if (userInitialData?.todoPublicado) {
    //   // no se pueden realizar cambios porque termino GDT
    //   toast.show(TEXTS.gdtHasEnded);
    //   resetState();
    //   return;
    // }
    // https://agea.atlassian.net/browse/DTA-7942

    if (player) {
      // se realiza posteo de nuevo capitan
      const response = await postNewCaptain({
        idCapitanActual: player.id,
        idCapitanNuevo: player.id,
      });
      if (response.estado) {
        resetState();
        setIsUpdateCaptain({ id: player.id, isUpdateCaptain: true });
      } else {
        toast.show(response.mensaje);
      }
    }
  };
  return {
    handleNewCaptain,
    responseNewCaptain,
    isLoadingNewCaptain,
    updateCaptain,
  };
};
